
const defaultRender = (value) => (value  ? value : '--');
const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
    },
    
    {
        title: 'Account Number',
        dataIndex: 'terminalLoginId',
    },
    {
        title: 'Account Type',
        dataIndex: 'accountType',
    },
    {
        title: 'Leverage',
        dataIndex: 'leverage',
    },
    {
        title: 'Balance',
        dataIndex: 'balance',
    },
    {
        title: 'Currency',
        dataIndex: 'currency',
    },
    
    {
        title: 'Request Time',
        dataIndex: 'createdDate',
        render: defaultRender,
    },

    {
        title: 'Action By',
        dataIndex: 'actionBy',
    },
    
    {
        title: 'Actions',
        dataIndex: 'actions',
    }

];

export default columns;